import type { IOsasReferralData } from '@common/validation/customControls/osas/osasReferralSchemas/osasReferralSchema';
import { Retrognathism, TongueSize, TonsilSize } from '@common/enums';
import { ImageSelectInput } from '@frontend/components/fields/ImageSelection';

export const tonsilSizeOptions = [
    {
        label: TonsilSize.status_na_tonsillectomie,
        url: 'assets/images/OSASC1/tonsil_1a.jpg',
        value: TonsilSize.status_na_tonsillectomie,
    },
    {
        label: TonsilSize.tonsillen_binnen_de_farynxbogen,
        url: 'assets/images/OSASC1/tonsil_2a.jpg',
        value: TonsilSize.tonsillen_binnen_de_farynxbogen,
    },
    {
        label: TonsilSize.tonsillen_vergroot_tot_de_farynxbogen,
        url: 'assets/images/OSASC1/tonsil_3a.jpg',
        value: TonsilSize.tonsillen_vergroot_tot_de_farynxbogen,
    },
    {
        label: TonsilSize.tonsillen_vergroot_tot_buiten_de_farynxbogen,
        url: 'assets/images/OSASC1/tonsil_4a.jpg',
        value: TonsilSize.tonsillen_vergroot_tot_buiten_de_farynxbogen,
    },
    {
        label: TonsilSize.tonsillen_vergroot_tot_de_mediaanlijn_kissing_tonsils,
        url: 'assets/images/OSASC1/tonsil_5a.jpg',
        value: TonsilSize.tonsillen_vergroot_tot_de_mediaanlijn_kissing_tonsils,
    },
    {
        label: TonsilSize.onbekend,
        url: 'assets/images/OSASC1/unknown_mouth.jpg',
        value: TonsilSize.onbekend,
    },
];

export const tongueSizeOptions = [
    {
        label: TongueSize.zichtbaar_zijn_uvula_tonsillen_en_farynxbogen_palatum_molle_en_durum,
        url: 'assets/images/OSASC1/tong_1a.jpg',
        value: TongueSize.zichtbaar_zijn_uvula_tonsillen_en_farynxbogen_palatum_molle_en_durum,
    },
    {
        label: TongueSize.uvula_partieel_zichtbaar_tonsillen_slechts_gedeeltelijk_palatum_molle_en_durum_wel,
        url: 'assets/images/OSASC1/tong_2a.jpg',
        value: TongueSize.uvula_partieel_zichtbaar_tonsillen_slechts_gedeeltelijk_palatum_molle_en_durum_wel,
    },
    {
        label: TongueSize.het_zachte_en_harde_verhemelte_zijn_zichtbaar_uvula_niet,
        url: 'assets/images/OSASC1/tong_3a.jpg',
        value: TongueSize.het_zachte_en_harde_verhemelte_zijn_zichtbaar_uvula_niet,
    },
    {
        label: TongueSize.allen_het_harde_verhemelte_is_zichtbaar,
        url: 'assets/images/OSASC1/tong_4a.jpg',
        value: TongueSize.allen_het_harde_verhemelte_is_zichtbaar,
    },
    {
        label: TongueSize.onbekend,
        url: 'assets/images/OSASC1/unknown_mouth.jpg',
        value: TongueSize.onbekend,
    },
];

export const retrognathismOptions = [
    {
        label: Retrognathism.overbeet,
        url: 'assets/images/OSASC1/retrognathie_Overbeet.svg',
        value: Retrognathism.overbeet,
    },
    {
        label: Retrognathism.normale_beet,
        url: 'assets/images/OSASC1/retrognathie_NormaleBeet.svg',
        value: Retrognathism.normale_beet,
    },
    {
        label: Retrognathism.onderbeet,
        url: 'assets/images/OSASC1/retrognathie_Onderbeet.svg',
        value: Retrognathism.onderbeet,
    },
    {
        label: Retrognathism.onbekend,
        url: 'assets/images/OSASC1/unknown_head.svg',
        value: Retrognathism.onbekend,
    },
];

export function ImageSelect<T extends keyof IOsasReferralData>(
    props: Readonly<{
        keyName: T;
        onChange: (data: Partial<IOsasReferralData>, validateKeys?: string | string[] | undefined) => void;
        options: typeof tongueSizeOptions | typeof retrognathismOptions | typeof tonsilSizeOptions;
        value: IOsasReferralData[T];
    }>
) {
    const { keyName, options, value, onChange } = props;

    return (
        <div className="image-selection-group">
            {options.map((option) => (
                <ImageSelectInput
                    checked={value === option.value}
                    key={option.value}
                    label={option.label}
                    name={keyName}
                    onChange={async (changedValue) => {
                        onChange({ [keyName]: changedValue as string }, keyName);
                    }}
                    url={`/${option.url}`}
                    value={option.value}
                />
            ))}
        </div>
    );
}
